export default "__VITE_ASSET__e7ce1d96__"